import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Faq.css";
import { useSEO } from "../../context/SEOContext";
import HeaderTarget from "../../components/HeaderTarget/HeaderTarget";
import FAQBtn from "../../components/FAQBtn/FAQBtn";
import FaqContact from "../../components/FaqContact/FaqContact";
import FaqCategory from "../../components/FaqCategory/FaqCategory";
// import faqData from "../../api/faqdata";
import { formatPage } from "../../utils/formatPage";
import { useFaqData } from "../../api/useFaqData";
import { useTranslation } from "react-i18next";
const shuffleArray = (array) => {
  const copy = [...array];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
};

const Faq = () => {
  const { t } = useTranslation();
  const faqData = useFaqData();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("faq.meta.title"),
      description: t("faq.meta.description"),
      keywords: t("faq.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);

  const allFaqs = faqData.flatMap((category) =>
    category.faqs.map((faq) => ({
      ...faq,
      category: category.text, // kategori adını da ekle
    }))
  );
  // Soruları rastgele sırala
  const shuffledFaqs = shuffleArray(allFaqs).slice(0, 6); // ilk 3 rastgele soru
  return (
    <>
      <HeaderTarget />
      <section className="bgcolorpage pt-5 pb-5">
        <div className="container pb-5">
          <div className="row">
            <div className="col-lg-5 mb-4">
              <FAQBtn />
            </div>
          </div>
          <div className="row">
            <h3 className="fw-light">{t("FAQTab")}</h3>
            <p className="fw-light fw-14">{t("FAQTabDesc")}</p>
          </div>

          <div className="row  align-items-stretch">
            <div className="col-lg-7 d-flex mt-3">
              <div className="bg-white text-center w-100">
                <h5 className="fw-light p-4 pb-1 bg-white text-start">
                  {t("THEMES")}
                </h5>
                <hr className="mb-0" />
                <div className="row g-0 align-items-center">
                  <FaqCategory />
                </div>
              </div>
            </div>
            <div className="col-lg-5 d-flex mt-3">
              <div className="bg-white w-100">
                <h5 className="fw-light p-4 pb-1 bg-white text-start">
                  {t("FREQUENTQUESTIONS")}
                </h5>
                <hr className="mb-0" />
                <div className="row p-4 fw-14">
                  {allFaqs.slice(0, 6).map((faq, index) => (
                    <Link
                      key={`${index}`}
                      to={`/faq/${formatPage(faq.category)}/${faq.id}`}
                      className={`text-dark fw-light d-block mb-2 pb-3 ${
                        index !== shuffledFaqs.length - 1 ? "border-bottom" : ""
                      }`}
                      style={{ padding: 10 }}
                    >
                      {faq.question}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-lg-7">
              <FaqContact />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
